import moment from 'moment-timezone';

export type AxisTick = { index: number; label: string };

type DatedPoint = { dateAndTime?: string | null };
type DayGroup = { first: number; last: number; label: string };

const DAY_KEY_FORMAT = 'YYYY-MM-DD';
const DAY_LABEL_FORMAT = 'DD/MM';

export const getDailyMidpointTicks = (points: DatedPoint[], timeZone: string): AxisTick[] => {
  const days = new Map<string, DayGroup>();

  points.forEach((point, index) => {
    if (!point.dateAndTime) return;

    const inZone = moment.utc(point.dateAndTime).tz(timeZone);
    if (!inZone.isValid()) return;

    const key = inZone.format(DAY_KEY_FORMAT);
    const group = days.get(key);
    if (group) {
      group.last = index;
    } else {
      days.set(key, { first: index, last: index, label: inZone.format(DAY_LABEL_FORMAT) });
    }
  });

  return [ ...days.values() ].map(({ first, last, label }) => ({
    index: Math.floor((first + last) / 2),
    label,
  }));
};
